export default {
	behaviourInstances: []
};
